import React, { useEffect } from "react";
import styles from "./styles/MyStudentProfilePage.module.css";
import clsx from "clsx";
import { Avatar } from "@components/common";
import { Link } from "react-router-dom";
import { Button, Col, Container, Nav, Row, Stack, Tab } from "react-bootstrap";
import { CourseExplorer } from "@components";
import { InstructorCard } from "@components/InstructorCard";
import { useDispatch, useSelector } from "react-redux";
import {
  allSubscriptionAction,
  getMyPurchasesAction,
  getProfileAction,
  getTotalReviewUserAction,
} from "@redux/actions";
import { myTotalEnrollmentAction } from "@redux/modules/enrollment/slices";

const MyStudentProfilePage = () => {
  // state
  const profile = useSelector((state) => state.user.profile.data);
  const myPurchased = useSelector(
    (state) => state.instructorCourse.myPurchases.data
  );
  const myTotalEnrollment = useSelector(
    (state) => state.enrollment.myTotalEnrollment.data
  );
  const totalReviewUser = useSelector(
    (state) => state.review.getTotalReviewUser.data
  );
  const unsubscribe = useSelector((state) => state.subscription.unsubscribe);
  const allSubscription = useSelector(
    (state) => state.subscription.allSubscription.data
  );

  // variables

  // logics before hooks

  // hooks
  const dispatch = useDispatch();

  // logics

  // UI partials
  const actionPart = (
    <div className="action">
      <Stack gap={2}>
        <Link to={"/setting"} className={"text-decoration-none text-white"}>
          <i className="bi bi-gear"></i> Setting
        </Link>
        <Link
          to={"/student-dashboard"}
          className={"text-decoration-none text-white"}
        >
          <Button variant="danger">Cursus Studio</Button>
        </Link>
      </Stack>
    </div>
  );
  const basicInfo = (
    <div className={clsx(styles.avatar, "d-flex align-items-center gap-3")}>
      <Avatar
        className="d-inline"
        src={
          profile?.avatarUrl
            ? profile.avatarUrl
            : "https://gambolthemes.net/html-items/cursus_main_demo/images/left-imgs/img-4.jpg"
        }
        width={80}
      />
      <div className="name text-white">
        <h5>{profile?.fullName}</h5>
        <div>{profile?.headLine}</div>
      </div>
    </div>
  );

  const statistic = (
    <div
      className={clsx(
        styles.statistic,
        "d-flex mt-4 w-100 justify-content-between flex-wrap"
      )}
    >
      <div className="info text-center py-2 flex-1">
        <h6>Purchased</h6>
        <span>{myPurchased?.length}</span>
      </div>
      <div className="info text-center py-2 flex-1">
        <h6>Enrolled</h6>
        <span>{myTotalEnrollment}</span>
      </div>
      <div className="info text-center py-2 flex-1">
        <h6>My Reviews</h6>
        <span>{totalReviewUser}</span>
      </div>
      <div className="info text-center py-2 flex-1">
        <h6>Subscriptions</h6>
        <span>{allSubscription?.length}</span>
      </div>
    </div>
  );

  // effects
  useEffect(() => {
    dispatch(getProfileAction());
    dispatch(getMyPurchasesAction());
    dispatch(myTotalEnrollmentAction());
    dispatch(getTotalReviewUserAction());
  }, []);

  useEffect(() => {
    dispatch(allSubscriptionAction());
  }, [unsubscribe]);

  // render
  return (
    <div className="">
      <div className={clsx(styles.header)}>
        <Container className="py-5">
          <Row>
            <Col lg={8} xs={12} className="leftSide mb-3">
              {basicInfo}
              {statistic}
            </Col>
            <Col lg={4} xs={12} className={clsx(styles.rightSide)}>
              {actionPart}
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid>
        <Tab.Container defaultActiveKey="about">
          <Row className={clsx(styles.tabContainer)}>
            <Col sm={12} className="bg-white">
              <Nav variant="pills" className="pt-4 container">
                <Nav.Item>
                  <Nav.Link eventKey="about">About</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="purchased">Purchased</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="subscription">Subscription</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey="about">
                  <Container className="pt-4 px-0">
                    <h4>About</h4>
                    {profile?.desc}
                  </Container>
                </Tab.Pane>
                <Tab.Pane eventKey="purchased">
                  <CourseExplorer
                    title={"My Purchased Course"}
                    extraSearchParams={{ isPurchased: true }}
                    courseType="learn"
                  />
                  {/* <Container className="pt-4 px-0">
                    <h4>Purchased Course</h4>
                    <Row className="mt-4">
                      {myPurchased.map((item, index) => {
                        return (
                          <Col lg={9} key={index} className="mb-3">
                            <CourseCard
                              data={item}
                              variant={"horizontal"}
                              type="learn"
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Container> */}
                </Tab.Pane>
                <Tab.Pane eventKey="subscription">
                  <Container className="pt-4 px-0">
                    <h4>Subscription</h4>
                    <Row>
                      {allSubscription.map((item, index) => {
                        return (
                          <Col
                            lg={3}
                            sm={6}
                            xs={12}
                            key={index}
                            className="mb-4"
                          >
                            <InstructorCard
                              data={item}
                              id={item.id}
                              instructorName={item.fullName}
                              desc={item.headLine}
                              imgUrl={item.avatarUrl}
                              variant={"subscribed"}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Container>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  );
};

/* required: display name */
MyStudentProfilePage.displayName = "MyStudentProfilePage";

/* required: props types */
MyStudentProfilePage.propTypes = {};

/* required: default props */
MyStudentProfilePage.defaultProps = {};

export { MyStudentProfilePage };
